import { CalciteTooltip } from '@esri/calcite-components-react';
import { CalciteTooltip as CalciteTip } from '@esri/calcite-components/dist/components';
import React from 'react';

type Props = {
  children: JSX.Element;

  // The text to display in the tooltip.
  content: React.ReactNode;

  label: string;
  placement?: CalciteTip['placement'];

  // Should tooltip content be contained to a single line?
  inline?: boolean;
};

export default function Tooltip({
  children,
  content,
  placement,
  label,
  inline,
}: Props) {
  const contentRef = React.useRef<HTMLDivElement>(null);

  const Child = React.cloneElement(children, {
    ref: contentRef,
  });

  return (
    <>
      {Child}
      <CalciteTooltip
        label={label}
        referenceElement={contentRef.current ?? undefined}
        placement={placement ?? 'auto'}
        overlayPositioning="fixed"
      >
        <div style={{ whiteSpace: inline ? 'nowrap' : 'inherit' }}>
          {content}
        </div>
      </CalciteTooltip>
    </>
  );
}
